import React from 'react';
import { Link } from 'react-router-dom';
import PaintTitle from './PaintTitle';

export default function QuantFeature({ project, featured = false, focusQuery = '' }) {
    if (!project) return null;
    return <section className="quant-feature" id={featured ? "featured" : "quant"}>
        <div className="work-heading"><span className="section-label">{featured ? "01 / Featured research" : "02 / Quantitative research"}</span><PaintTitle>{featured ? project.title : "Statistical arbitrage research"}</PaintTitle></div>
        <div className="quant-layout">
            <div>
                <p>I built a Python pipeline to screen equity pairs with cointegration tests and backtest a pairs-trading strategy with transaction costs. The central comparison: a static hedge ratio versus an adaptive estimate using a Kalman filter.</p>
                <p>This project connects my background in signals and estimation to an interest in quantitative research and development. The results shown are from a research backtest.</p>
                <Link to={`/project/${project.id}${focusQuery}`}>Explore the research</Link>
            </div>
            <figure><Link to={`/project/${project.id}${focusQuery}`}><img src={project.images[1]} alt="Backtest chart comparing static and Kalman filter pairs-trading models for AMAT and NXPI" loading="lazy" /></Link><figcaption>AMAT / NXPI model comparison from the project backtest.</figcaption></figure>
        </div>
    </section>;
}
